import { render } from "./CreateAdmin.vue?vue&type=template&id=83dd8e3a&scoped=true"
import script from "./CreateAdmin.vue?vue&type=script&lang=js"
export * from "./CreateAdmin.vue?vue&type=script&lang=js"

import "./CreateAdmin.vue?vue&type=style&index=0&id=83dd8e3a&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83dd8e3a"]])

export default __exports__